import { format, setDay } from 'date-fns/fp';

export default function WeekHeader({ firstDayOfWeek = 0 }) {
	return (
		<thead>
			<tr>
				{[0, 1, 2, 3, 4, 5, 6]
					.map(i => setDay((i + firstDayOfWeek) % 7)(new Date()))
					.map(date => (
						<th
							aria-hidden="true"
							key={format('EEEEEE')(date)}
							className="DayPicker_container ty-b2"
						>
							<small>{format('EEEEE')(date)}</small>
						</th>
					))}
			</tr>
		</thead>
	);
}
